<template>
    <el-card class="assign-saler-table">
        <div class="search-div flex items-center">
            <el-input class="search-input" v-model="form.keyword" :placeholder="$t('Reception.Second.search_placeholder')" />
        <div class="pl-6">
            <el-button type="primary" @click="fetchData">{{ $t('Common.search') }}</el-button>
            <el-button type="primary" @click="handleReset">{{ $t('Common.clear') }}</el-button>
        </div>
        </div>
        <div class="title">
            <p class="title-3a">
                {{ $t('Charge.search') }}：共{{this.totalCount}}名客户 ，
                {{ $t('Member.member') }}{{this.fullClientCount}}名，{{ $t('Common.prospective_customer') }}{{this.potentialClientCount}}名，
                {{ $t('Client.Paymentratio') }}{{this.fullPercent}}
            </p>
        </div>
        <el-table
            border
            ref="tableData"
            v-if="tableData"
            :data="tableData"
            class="my-4"
            v-loading="loading"
            @row-click="clickRow"
            @selection-change="handleSelectChange"
        >
            <el-table-column type="selection" width="30px"></el-table-column>
            <el-table-column prop="id" :label="$t('Card.client_id')" align="center" width="60px" v-if="false"/>
            <el-table-column prop="salesProtectDays" :label="$t('Reception.Second.day')" align="center" />
            <el-table-column prop="editorStaffNickname" :label="$t('Member.Desc.entry')" align="center" />
            <el-table-column prop="createdAt" :label="$t('Client.entry_date')" align="center" />
            <el-table-column prop="mshpSalesNickname" :label="$t('Client.Currentsales')" align="center" width="100px"/>
            <el-table-column prop="salesFollowAt" :label="$t('Member.Follow.Last_follow-up')" align="center"/>
            <el-table-column prop="name" :label="$t('Card.client_name')" align="center"/>
            <el-table-column prop="gender" :label="$t('Common.gender')" align="center" width="50px"/>
            <el-table-column prop="phone" :label="$t('Common.phone_number')" align="center" width="110px"/>
            <el-table-column prop="salesFollowStatus" :label="$t('Member.Follow.table_coach_status')" align="center"/>
            <el-table-column prop="cardNames" :label="$t('Card.service')" align="center"/>
            <el-table-column prop="type" :label="$t('Client.type')" align="center"/>
            <el-table-column prop="mshpAt" :label="$t('Member.enter_date')" align="center" width="100px"/>
            <el-table-column prop="mshpExpiredAt" :label="$t('Member.end')" align="center" width="100px"/>
            <el-table-column prop="clientTagNames" :label="$t('Client.Add.customer_label')" align="center"/>
            <el-table-column prop="activeName" :label="$t('Client.Add.status')" align="center"/>
        </el-table>

        <el-dialog :visible.sync="visible" :title="$t('Client.select_memberships_sales')" left>
            <p style="font-size:13px;">
                {{ $t('Client.SelectedPotentCustomers') }}{{clients.length}}{{ $t('Client.name_tobeassigned') }}
            </p>
            <el-table
                border
                v-if="assignSales"
                :data="assignSales"
                v-loading="loading"
                highlight-current-row
                @current-change="salesSelectChange"
            >
                <el-table-column prop="id" :label="$t('Client.MembershipSalesID')" v-if="false"/>
                <el-table-column prop="nickname" :label="$t('Common.saler')" align="center"/>
                <el-table-column prop="potentialClientCount" :label="$t('Common.prospective_customer')" align="center" width="120"/>
                <el-table-column prop="fullClientCount" :label="$t('Member.member')" align="center"/>
            </el-table>
            <div slot="footer" class="dialog-footer"  style="text-align:center">
                <el-button @click="confirm" type="primary">{{ $t('Course.allot') }}</el-button>
            </div>
        </el-dialog>

        <!-- 分页 -->
        <el-pagination
            v-if="tableData"
            class="text-center"
            @current-change="fetchData"
            :current-page.sync="form.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>
    </el-card>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
    },
    props: ['activeName'],
    data() {
        return {
            assignSales: [],
            visible: false,
            clients: [],
            staffId: '',
            form: {
                keyword: '',
                page: 1,
            },
            saleForm: {
                clientIds: [],
                staffId: '',
            },
            totalCount: 0,
            potentialClientCount: 0,
            fullPercent: '',
            fullClientCount: 0,
            loading: false,
            tableData: [],
            clientIds: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
            rules: {
                staffId: { required: true, message: this.$t('Common.distribution_saler_placeholder') },
            },
        };
    },
    watch: {
        activeName(val) {
            if (val === 'third') this.fetchData(1);
        },
    },
    methods: {
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get('client/assign-sales', {
                params: { ...this.form, ...this.pagination },
            }).then(res => {
                this.fullPercent = res.fullPercent;
                this.fullClientCount = res.fullClientCount;
                this.potentialClientCount = res.potentialClientCount;
                this.totalCount = Number(this.fullClientCount) + Number(this.potentialClientCount);
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
            }).finally(() => {
                this.loading = false;
            });
        },
        say(data) {
            this.form = data;
            this.fetchData(1);
        },
        handleReset() {
            this.form = {};
            this.fetchData(1);
        },
        handleAssign() {
            this.visible = true;
            this.saleForm.clientIds = this.clientIds;
            this.fetchAssign();
        },
        salesSelectChange(val) {
            this.staffId = val.id;
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        handleSelectChange(val) {
            this.clientIds = val.map(el => el.id);
            this.clients = val;
            this.$emit('listenClientIds', this.clients);
        },
        fetchAssign() {
            this.loading = true;
            API.get('client/sales-client-count').then(res => {
                this.assignSales = res;
            }).finally(() => {
                this.loading = false;
            });
        },
        confirm() {
            if (this.validSelect()) {
                this.loading = true;
                this.saleForm.staffId = this.staffId;
                API.post('client/assign-sales', this.saleForm).then(() => {
                    $ele.$message.success(this.$t('Message.save'));
                }).finally(() => {
                    this.loading = false;
                    this.visible = false;
                    this.fetchData();
                }).catch(err => {
                    $ele.$message.error(err);
                });
            }
        },
        validSelect() {
            if (!this.staffId) $ele.$message.warning(this.$t('Message.choose_member_for_sale'));
            else return true;
        },
    },
    created() {
        if (this.activeName === 'third') this.fetchData(1);
    },
};
</script>
<style lang="scss">
.assign-saler-table {
    .el-dialog {
        max-height: 800px;
    }
    .el-dialog__body {
        max-height: 700px;
        overflow-y: auto;
    }
    .title {
        margin-top: 30px;
        width: 98%;
    }
    .title-3a {
        height: 50px;
        color: grey;
        line-height: 70px;
        font-size: 12px;
    }
    .search-div {
        position: absolute !important;
        left: 20px;
        top: 20px;
        padding-bottom: 15px;
    }
    .search-input {
        width: 300px;
    }
}
</style>
